import React from "react";

const AIDemo = () => {
  const container = { maxWidth: "800px", margin: "0 auto", padding: "120px 20px", color: "#fff", textAlign: 'center', fontFamily: "'Plus Jakarta Sans', sans-serif" };
  const glassInput = { width: "100%", padding: "15px", marginBottom: "20px", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "10px", color: "#fff" };

  return (
    <div style={{ backgroundColor: "#05070a", minHeight: "100vh" }}>
      <div style={container}>
        <h4 style={{ color: "#00d4ff", letterSpacing: "3px" }}>EXPERIENCE COGNITIVE COMPUTING</h4>
        <h1 style={{ fontSize: "3.5rem", marginBottom: "30px" }}>Book a Live <span style={{ color: "#00d4ff" }}>AI Demo</span></h1>
        <p style={{ color: "#8b949e", marginBottom: "50px" }}>See our custom LLMs and RAG systems in action using real-world business datasets.</p>

        <div style={{ background: "rgba(255,255,255,0.02)", padding: "40px", borderRadius: "30px", border: "1px solid rgba(255,255,255,0.1)" }}>
          <form>
            <input type="text" placeholder="Your Name" style={glassInput} />
            <input type="email" placeholder="Corporate Email" style={glassInput} />
            <select style={glassInput}>
              <option>Interested in: Custom Chatbots</option>
              <option>Interested in: LLM Fine-tuning</option>
              <option>Interested in: Workflow Automation</option>
            </select>
            <button style={{ background: "#00d4ff", color: "#05070a", padding: "18px 40px", borderRadius: "50px", border: "none", fontWeight: "800", cursor: "pointer", width: "100%" }}>
              Request Demo Access
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AIDemo;